/*
THIS CODE WORKS WITH BACK IN STOCK API from SureSwift APP
https://apps.shopify.com/back-in-stock
 */

$(document).on('ready', function(){
        const BACKINSTOCK = {
            $addToCart: $("[data-btn-add-to-cart]"),
            $backInStock: $("[data-btn-back-in-stock]"),
            loaded: false,
            backInStockIframe: document.getElementById('BIS_frame')
        }

        BACKINSTOCK.init = function(){
            BACKINSTOCK.backInStockIframe = document.getElementById('BIS_frame');

            if (!BACKINSTOCK.backInStockIframe) return;

            var backInStockIframeBody = BACKINSTOCK.backInStockIframe.contentDocument.body;

            // Translations
            if(window._BIS_i18n) {
                var $modalTitle = $(backInStockIframeBody).find('.modal-title');
                var $modalDesc = $modalTitle.find('+ p');
                var $emailInput = $(backInStockIframeBody).find('[type="email"]');
                var $modalButton = $(backInStockIframeBody).find('[type="submit"]');
                var $modalDisclaimer = $(backInStockIframeBody).find('form + .small-print');
                var $modalError = $(backInStockIframeBody).find('.alert-danger');
                var $modalSuccess = $(backInStockIframeBody).find('.alert-success');
                $modalTitle.html(window._BIS_i18n.modal_title);
                $modalDesc.html(window._BIS_i18n.modal_description);
                $emailInput.get(0).setAttribute('placeholder', window._BIS_i18n.modal_placeholder);
                $modalError.html(window._BIS_i18n.error);
                $modalSuccess.html(window._BIS_i18n.success);
                $modalButton.html(window._BIS_i18n.modal_button);
                $modalDisclaimer.html(window._BIS_i18n.modal_disclaimer);
                BACKINSTOCK.$backInStock.html(window._BIS_i18n.button);
            }

            // End Translations

            BACKINSTOCK.loaded = true;
        }

        $('[data-product-form]').on('mousedown', function(){
            if(BACKINSTOCK.loaded) return;

            BACKINSTOCK.init();
        });

        $('.template-product__section').on('variantChange', function(e){
            if(typeof BIS !== 'undefined' && typeof BISConfig !== 'undefined') {
                if(e.variant) {
                    if (!e.variant.available) {
                        BACKINSTOCK.$addToCart.hide();
                        BACKINSTOCK.$backInStock.attr('data-variant-id', e.variant.id);
                        BACKINSTOCK.$backInStock.show();
                    } else {
                        BACKINSTOCK.$addToCart.show();
                        BACKINSTOCK.$backInStock.hide();


                    }
                }
            }
        });
});
